import { Link } from "react-router-dom";
import EnlaceCotizar from "../components/ui/EnlaceCotizar.jsx";
import { EMPRESA } from "../lib/config";
import p from "./Pagina.module.css";

/**
 * Esta pagina esta escrita para no afirmar nada que no podamos verificar:
 * no hay anos de fundacion, numero de clientes ni metros cuadrados inventados.
 * El aviso de arriba recuerda que falta la historia real de la empresa.
 */
export default function Nosotros() {
  return (
    <>
      <header className={p.cabecera}>
        <div className="container">
          <p className="eyebrow">Nosotros</p>
          <h1 className={p.titulo}>{EMPRESA.eslogan}</h1>
          <p className={p.subtitulo}>
            Somos un taller de transformacion de acero en {EMPRESA.ciudad}:
            cortamos, plegamos y rolamos plancha, y vendemos el material.
          </p>
        </div>
      </header>

      <section className={`container ${p.cuerpo}`}>
        <div className={p.prosa}>
          <h2>Que hacemos</h2>
          <p>
            Transformamos plancha metalica: <strong>corte laser</strong>,{" "}
            <strong>oxicorte</strong>, <strong>plegado</strong> y{" "}
            <strong>rolado</strong>, con maquinaria propia en nuestra planta de
            Arequipa. Ademas vendemos el material que trabajamos: planchas
            metalicas y ejes redondos solidos.
          </p>

          <h2>Como entendemos el trabajo</h2>
          <p>
            Un trabajo de maestranza falla casi siempre por lo mismo: la pieza
            sale con una medida distinta a la del plano, el plazo se corre, o
            el precio cambia a ultima hora. Por eso confirmamos el plano antes
            de cortar, cerramos el precio en la cotizacion y damos una fecha
            que podamos cumplir.
          </p>

          <h2>Con quienes trabajamos</h2>
          <p>
            Atendemos por igual al taller metalmecanico que necesita una serie
            de piezas plegadas y al cliente que llega con una sola pieza y un
            croquis a mano. La diferencia esta en el volumen, no en el trato ni
            en el cuidado del trabajo.
          </p>
        </div>
      </section>

      <section className="section section--dark">
        <div className="container">
          <p className="eyebrow">Compromisos</p>
          <h2 style={{ color: "var(--dark-ink)", marginBottom: "2rem" }}>
            Lo que si podemos garantizar
          </h2>

          <div className={p.grid}>
            {[
              {
                titulo: "El plano se confirma antes de cortar",
                texto:
                  "Revisamos medidas, espesor y dobleces contigo. Preferimos una consulta de mas que una pieza mal cortada.",
              },
              {
                titulo: "Precio sin letra chica",
                texto:
                  "La cotizacion incluye IGV y, si corresponde, el material y el flete. Lo que firmas es lo que pagas.",
              },
              {
                titulo: "Maquinaria propia",
                texto:
                  "No tercerizamos el corte ni el plegado, asi que el plazo que te damos depende de nosotros.",
              },
            ].map((item) => (
              <article
                key={item.titulo}
                className={p.tarjeta}
                style={{
                  background: "transparent",
                  borderColor: "var(--dark-line)",
                }}
              >
                <h3
                  className={p.tarjetaTitulo}
                  style={{ color: "var(--dark-ink)" }}
                >
                  {item.titulo}
                </h3>
                <p
                  className={p.tarjetaTexto}
                  style={{ color: "var(--dark-ink-soft)" }}
                >
                  {item.texto}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className={`container ${p.cuerpo}`}>
        <div className={p.centrado} style={{ marginInline: 0, maxWidth: "58ch" }}>
          <h2>Trabajemos juntos</h2>
          <p className={p.tarjetaTexto}>
            Envianos tu plano o tu lista de materiales y te respondemos con
            precio y plazo.
          </p>
          <div className={p.acciones}>
            <EnlaceCotizar className="btn btn--accent">
              Pedir cotizacion
            </EnlaceCotizar>
            <Link to="/productos" className="btn btn--ghost">
              Ver catalogo
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
